export enum ZPrinterDeviceType {
  POS = 'pos',
  PRINTER = 'printer',
  FISCAL_PRINTER = 'fiscal_printer',
  DRAWER = 'drawer',
  SCALE = 'scale',
  KITCHEN_MONITOR = 'kitchen_monitor',
}
